import { useMediaQuery, useTheme } from '@mui/material';

export const useIsRecordingAnnouncementViewport = () => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.up('laptop'), { noSsr: true });
};
